import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Search from './Search.js'

import favourite from '../assets/Favourite.svg';
import dropDown from '../assets/dropDown.svg';
import back from '../assets/Back.svg';
import note from '../assets/Note.svg';


export default function Brand() {
    // const location = useLocation();
    const [brandItems, setBrandItems] = useState([]);
    const [brandFavouriteItem, setBrandFavouriteItem] = useState([]);
    // const [query, setQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const userId = sessionStorage.getItem('userId');
    // const favouriteItems = [{ type: 'Brand', item: 'Resync', id: 1 }, { type: 'Brand', item: 'Azithral', id: 2 }];

    useEffect(() => {
        const apiUrl = `https://alembicdigilabs.in/medicaldictionary/v1/eyecare/brands?userId=${userId}`;

        // Fetching data
        fetch(apiUrl,{
            method: 'GET',
            headers: {
                'authorization': `bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                // setData(data);  // Save the response data to state
                // setLoading(false);
                setBrandItems(data.brands)

            })
            .catch((error) => {
                // setError(error.message);  // Handle any errors
                // setLoading(false);
                console.log(error);

            });
    }, []);

    useEffect(() => {
        const apiUrl = `https://alembicdigilabs.in/medicaldictionary/v1/eyecare/favourites/${userId}?type=brands`;

        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'authorization': `bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                setBrandFavouriteItem(data.data);
            }).catch(error => {
                console.log(error);
            })
    }, [])

    const handleSearch = useCallback(async (query) => {
            if (query.length === 0) {
                setSearchResults([]);
                setIsSearching(false);
                return;
            }
            setIsSearching(true);
            try {
                // const response = await fetch("https://alembicdigilabs.in/medicaldictionary/v1/eyecare/keyword-search", {
                const response = await fetch(`https://alembicdigilabs.in/medicaldictionary/v1/eyecare/search?query=${query}&userId=${userId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        'authorization': `bearer ${sessionStorage.getItem('token')}`
                    },
                }); // Fetch from public folder
                const data = await response.json();
    
                // Filter results based on query
                // const filteredResults = data.results.filter(item =>
                //     item.name.toLowerCase().includes(query.toLowerCase())
                // );
                setSearchResults(data.results);
            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        },[]);

    return (
        <div className="dictionary-container">

            {/* Header */}
            <header className="text-left py-3 d-flex gap-3">
                <Link to="/dictionary" className="text-decoration-none align-self-center">
                    <img src={back} alt="Back" className="dictionary-icon mb-3" />
                </Link>
                <p className='dictionaryHeader'>Brand</p>
            </header>

            {/* Search Bar */}

            <Search onSearch={handleSearch} />

            {isSearching ? (
                <div className="mt-3">
                    {searchResults.length > 0 ? (
                        <ul className="list-group">
                            {searchResults.map((item, index) => (
                                <li key={index} className="list-group-item">
                                    <Link to={`/brandDetails/${item.id}`} className="text-decoration-none text-secondary"
                                        state={{ from: "/brand", brandDetails: item, isFavorite: item.favourite }}>
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-muted">No results found</p>
                    )}
                </div>
            ) : (<>


                {/* Your Favourite Section */}
                {brandFavouriteItem.length !==0 && (
                    <div className="favourite-section">
                        <div className='favourite-header'>
                            <img src={favourite} alt="Card 2" className="" />
                            <p>Your Favourite</p>
                        </div>
                        <ul className="favourite-list">
                            {brandFavouriteItem.map((item, index) => (
                                <li key={index} className="favourite-item">
                                    <Link to={`/brandDetails/${item.id}`} className="text-decoration-none text-secondary"
                                        state={{ from: "/brand", brandDetails: item, isFavorite: true }}>
                                        {item.Name}
                                    </Link>
                                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                        <div className='type-container'>
                                            <span className={`favourite-type ${item.Type === 'Brand' ? 'orange' : 'blue'}`}>{item.Type}</span>
                                        </div>
                                        <img src={dropDown} alt="Dropdown" className="dropdown-icon" />
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}



                {/* Brand Section */}
                <div className="favourite-section">
                    <div className='favourite-header'>
                        <img src={note} alt="Card 2" className="" />
                        <p>Brand List</p>
                    </div>
                    <ul className="favourite-list">
                        {brandItems.map((item, index) => (
                            <li key={index} className="favourite-item">
                                <Link to={`/brandDetails/${item.id}`} className="text-decoration-none text-secondary"
                                    state={{ from: "/brand", brandDetails: item, isFavorite: item.favourite }}>
                                    {item.Brand}
                                </Link>
                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                    <div className='type-container'>
                                        <span className={`favourite-type orange`}>Brand</span>
                                    </div>
                                    <img src={dropDown} alt="Dropdown" className="dropdown-icon" />
                                </div>
                            </li>
                        ))}
                    </ul>
                </div></>)}
        </div>
    );
}
